'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Log = require('../../shared/Log');

var _players = require('../../store/actions/players');

var mapStateToProps = function mapStateToProps(state, ownProps, _ref) {
  var playerId = _ref.playerId;

  var player = state.players[playerId];
  var playable = player.playables.get(player.playingIndex);

  return {
    streams: playable ? playable.streams : null,
    currentTimeMs: player.currentTimeMs || 0,
    playerId: playerId,
    selectedStreamId: player.selectedStreamId,
    contextMenuOpen: player.contextMenuOpen
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref2) {
  var playerId = _ref2.playerId;

  return {
    pauseAction: function pauseAction() {
      dispatch((0, _players.pause)(playerId, true));
    },
    playAction: function playAction() {
      dispatch((0, _players.play)(playerId, true));
    },
    selectStream: function selectStream(streamId, streamName) {
      (0, _Log.log)(playerId, 'SetStream', {
        streamName: streamName,
        streamId: streamId
      });
      dispatch((0, _players.setStream)(playerId, streamId));
    },
    setContextMenu: function setContextMenu(value) {
      dispatch((0, _players.setContextMenu)(playerId, value));
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];